import { WorldRepositoriesProvider } from '_/features/world/ui/contexts/world-repositories-provider'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const WorldLayout = () => (
	<WorldRepositoriesProvider>
		<Outlet />
	</WorldRepositoriesProvider>
)

export const Route = createFileRoute('/_authenticated/world')({
	component: WorldLayout,
})
